import React from 'react';
import { ALP_LOGO } from '../lib/assets';

// Australian Luxe Peptides circular monogram (uploaded brand logo)
export default function Logo({ size = 48 }) {
  return (
    <img
      src={ALP_LOGO}
      alt="Australian Luxe Peptides"
      width={size}
      height={size}
      style={{ width: size, height: size, borderRadius: '9999px', objectFit: 'cover' }}
      className="select-none"
    />
  );
}
